import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import {
    Box,
    IconButton,
    Typography,
} from '@mui/material';
import {
    Check,
    Undo,
} from '@mui/icons-material';

import { HasPermissions } from '../../contexts/PermissionContext';
import SettingsTextField from '../textfield/SettingsTextField';


function CrewSettings({ schema = {}, settings = {}, setSettings = () => {} }) {

    const [crewSettings, setCrewSettings] = useState(settings);

    useEffect(() => {
        setCrewSettings(settings)
    }, [settings])

    function handleChange(field, value) {
        const updatedSettings = _.cloneDeep(crewSettings);
        updatedSettings[field] = value;
        updateSettings(updatedSettings);
    }

    function handleDiscard() {
        updateSettings(settings);
    }

    function updateSettings(newSettings) {
        setCrewSettings(newSettings);
        setSettings(newSettings);
    }

    return (
        <Box
            display="flex"
            border={'1px solid rgba(139, 142, 146, 1)'}
            borderRadius={4}
            position="relative"
        >
            {
                !_.isEqual(settings, crewSettings) && 
                <Box
                    position="absolute"
                    top={0}
                    right={0}
                    p={1}
                >
                    <IconButton
                        sx={{
                            color: 'rgba(180, 120, 120, 0.7)', // muted red
                            transition: 'color 0.2s',
                            '&:hover': {
                                color: 'rgb(211, 47, 47)', // vivid red
                            },
                        }}
                        onClick={handleDiscard}
                    >
                        <Undo
                            sx={{
                                fontSize: '16px',
                            }}
                        />
                    </IconButton>
                    <IconButton
                        sx={{
                            color: 'rgba(120, 180, 120, 0.7)', // muted green
                            fontSize: '16px',
                            transition: 'color 0.2s',
                            '&:hover': {
                                color: 'rgb(46, 225, 50)', // vivid green
                            },
                        }}
                    >
                        <Check
                            sx={{
                                fontSize: '16px',
                            }}
                        />
                    </IconButton>
                </Box>
            }
            <Box
                m={2}
                display="flex"
                flexDirection="column"
                gap={2}
            >
                <Typography
                    variant="h6"
                >
                    Crew Settings
                </Typography>

                <SettingsTextField
                    description={schema?.data?.Director?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.Director?.label ?? 'Director'}
                    onChange={(value) => handleChange('Director', value)}
                    original={settings?.Director ?? ''}
                    value={crewSettings?.Director ?? ''}
                />

                <SettingsTextField
                    description={schema?.data?.DOP?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.DOP?.label ?? 'Director of Photography'}
                    onChange={(value) => handleChange('DOP', value)}
                    original={settings?.DOP ?? ''}
                    value={crewSettings?.DOP ?? ''}
                />

                <SettingsTextField
                    description={schema?.data?.['QC Operator']?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.['QC Operator']?.label ?? 'QC Operator'}
                    onChange={(value) => handleChange('QC Operator', value)}
                    original={settings?.['QC Operator'] ?? ''}
                    value={crewSettings?.['QC Operator'] ?? ''}
                />

                <SettingsTextField
                    description={schema?.data?.['Data Wrangler']?.description ?? ''}
                    disabled={!HasPermissions(schema?.permissions?.write)}
                    label={schema?.data?.['Data Wrangler']?.label ?? 'Data Wrangler'}
                    onChange={(value) => handleChange('Data Wrangler', value)}
                    original={settings?.['Data Wrangler'] ?? ''}
                    value={crewSettings?.['Data Wrangler'] ?? ''}
                />

            </Box>
        </Box>
    );
}

export default CrewSettings;